import React, { useCallback, useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Refresh } from '@mui/icons-material';
import axios from '../../utils/axiosConfig';

// Product reports are stored as REPORT notifications; blocking is not implemented yet.
const ReportedAndBlocked = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadReports = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get('/notifications/reports');
      setReports(response.data?.reports || []);
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to load reports');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadReports();
  }, [loadReports]);

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Reported Products
        </Typography>
        <Button size="small" startIcon={<Refresh />} onClick={loadReports} disabled={loading}>
          Refresh
        </Button>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : reports.length === 0 ? (
        <Alert severity="info">No products have been reported.</Alert>
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>User ID</TableCell>
                <TableCell>Product ID</TableCell>
                <TableCell>Product Name</TableCell>
                <TableCell>Block Reason</TableCell>
                <TableCell>Report Reason</TableCell>
                <TableCell>Reported At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reports.map((report, idx) => (
                <TableRow key={report.reportId || idx}>
                  <TableCell sx={{ fontFamily: 'monospace' }}>{report.userId || '-'}</TableCell>
                  <TableCell sx={{ fontFamily: 'monospace' }}>{report.productId || '-'}</TableCell>
                  <TableCell>{report.productName || '-'}</TableCell>
                  <TableCell>-</TableCell>
                  <TableCell>{report.reportReason || '-'}</TableCell>
                  <TableCell>
                    {report.createdAt ? new Date(report.createdAt).toLocaleString() : '-'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default ReportedAndBlocked;
